import { FC } from "react";
import { ProductCardWishlist } from "src/organisms/ProductCardWishlist";
import { Box } from "@otrium/core";
import { CatalogBrand, CatalogProduct } from "src/types/graphql.d";
import { DeprecatedAlgoliaSearchProduct } from "src/types/Algolia";
import { SegmentProductList } from "src/hooks/useSegmentProductList";
import { ProductFilteredLabels } from "src/hooks/useFilterProductLabels";
import {
  GATED_PLP_FAVOURITE_SOURCE,
  GATED_PLP_PRODUCT_CARD_SOURCE,
} from "src/constants/gatedItem";
import { GatedPopupTrackingProps } from "src/types/GatedPopup";
import { ProductRedirect } from "../ProductCardWishlist/ProductCardWishlist";

interface Props {
  product: DeprecatedAlgoliaSearchProduct;
  labels: ProductFilteredLabels;
  index: number;
  segmentProductOnClick: SegmentProductList["segmentProductOnClick"];
  setVisibleProducts: SegmentProductList["setVisibleProducts"];
  queryID: string;
  algoliaIndex: string;
  indexName: string;
  trackingData: GatedPopupTrackingProps;
  setProductRedirect?: (
    type: string,
    product?: ProductRedirect,
    actionSource?: string,
    position?: number
  ) => void;
}

const CustomHit: FC<Props> = ({
  algoliaIndex,
  index,
  product,
  labels,
  queryID,
  indexName,
  segmentProductOnClick,
  setVisibleProducts,
  trackingData,
  setProductRedirect,
}) => {
  const brandImages = product?.brand?.images || [];

  const productProps = {
    ...product,
    id: product.objectID,
    name: product.name,
    price: product.price,
    regular_price: product.regular_price,
    brand: {
      name: product.brand_name || "",
    } as CatalogBrand,
    thumbnail: product.image || "",
    labels: labels[product.slug],
    images: brandImages,
  } as CatalogProduct;

  return (
    <Box px={[2, 2, 2, 2, 0]}>
      <ProductCardWishlist
        {...product}
        product={productProps}
        segmentProductOnClick={segmentProductOnClick}
        setVisibleProducts={setVisibleProducts}
        position={index}
        queryID={queryID}
        algoliaIndex={algoliaIndex}
        indexName={indexName}
        trackingData={trackingData}
        setProductRedirect={setProductRedirect}
        plpActionSource={GATED_PLP_PRODUCT_CARD_SOURCE}
        plpAddToFavoriteActionSource={GATED_PLP_FAVOURITE_SOURCE}
      />
    </Box>
  );
};

export { CustomHit };
